import { PLACEHOLDER_QUALITY } from '../common/constants';

export const getImageUrl = url => {
  if (url?.endsWith('.svg') || url?.endsWith('.gif')) {
    return `${url}?q=${PLACEHOLDER_QUALITY}`;
  }
  return `${url}?fm=webp&q=${PLACEHOLDER_QUALITY}`;
};
